<p-chip class="custom-chip" [class.custom-chip--link]="isLink" label="{{label}}" [pTooltip]="tooltip || ''"
    [tooltipDisabled]="!tooltip" tooltipPosition="top" [attr.role]="isLink ? 'link' : null"
    [attr.tabindex]="isLink ? 0 : null" (click)="onClick()" (keydown.enter)="onClick()" />